import Vue from 'vue';
import DatetimePicker from '../components/Utility/DatetimePicker.vue';

// Register the component globally
Vue.component('v-datetime-picker', DatetimePicker);